import connector from '@/store/util/connector';

import {
  INITIALIZE_APP,
  GET_LOGIN_USER_DATA,
  GET_CONFIG_DATA,
  GET_MEMBER_DATA,
  GET_MEMBERS_WITH_AUTHORITY_DATA,
  GET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA,

  SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST,
  SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_WITHDRAW,
  SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_AGREE,
  SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_APPROVE,

  SUBMIT_MEMBER_EDIT_DATA,
  SUBMIT_JOB_CREATE_DATA,
  SUBMIT_JOB_EDIT_DATA,
  SUBMIT_JOB_REMOVE_DATA,

  SUBMIT_TEAM_CREATE_DATA,
  SUBMIT_TEAM_EDIT_DATA,
  SUBMIT_TEAM_REMOVE_DATA,
  SUBMIT_ADD_MEMBER_TO_TEAM_DATA,

  // alarm
  SET_SLACK_ALARM,
} from './actions-types';

export default {
  [INITIALIZE_APP]() {
    // console.log('INITIALIZE_APP (action) =========================== ');
    this.dispatch('GET_LOGIN_USER_DATA');
    // this.dispatch('GET_CONFIG_DATA');
  },

  [GET_LOGIN_USER_DATA](state) {
    // console.log('GET_LOGIN_USER_DATA (action) =========================== ');
    const url = '/session/v1.json';
    const params = {};

    connector.getLoginUserAIP(this, state, url, params);
  },

  [GET_CONFIG_DATA]({ state }) {
    // console.log('GET_CONFIG_DATA (action) =========================== ');
    const url = '/admin/authority/all.json';
    const params = {
      company: state.base.company,
    };

    connector.getConfigAPI(this, state, url, params);
  },

  [GET_MEMBER_DATA](state, member) {
    // console.log('GET_MEMBER_DATA (action) =========================== ');
    const url = '/admin/authority/member.json';
    const params = {
      id: member.id,
      company: member.company,
    };

    connector.getMemberAPI(this, state, url, params);
  },

  [GET_MEMBERS_WITH_AUTHORITY_DATA](state, payload) {
    console.log('GET_MEMBERS_WITH_AUTHORITY_DATA (action) =========================== ');
    const url = '/admin/authority/logs.json';
    const params = {
      serviceId: payload.serviceId,
      domainId: payload.domainId,
      actionId: payload.actionId,
      dt: payload.dt,
    };

    connector.getMembersWithAuthorityAPI(this, state, url, params);
  },

  [GET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA](state, payload) {
    console.log('GET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA (action) =========================== ', payload);
    const url = '/admin/authority/logs/view.json';
    const params = {
      serviceId: payload.serviceId,
      domainId: payload.domainId,
      actionId: payload.actionId,
      dt: payload.dt,
      userId: payload.userId,
    };

    connector.getLogOfMemberWithAuthorityAPI(this, state, url, params);
  },

  [SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST](state, payload) {
    // console.log('SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST (action) =========================== ', payload);
    const url = '/admin/authority/member/team/role/request.json';
    const params = payload;

    connector.setMemberAffiliatedTeamRoleRequest(this, state, url, params);
  },

  [SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_WITHDRAW](state, payload) {
    // console.log('SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_WITHDRAW (action) =========================== ', payload);
    const url = '/admin/authority/member/team/role/request/withdraw.json';
    const params = {
      request_id: payload,
    };

    connector.setMemberAffiliatedTeamRoleRequestWithdrawAPI(this, state, url, params);
  },

  [SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_AGREE](state, payload) {
    // console.log('SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_AGREE (action) =========================== ', payload);
    const url = '/admin/authority/member/team/role/request/agree.json';
    const params = payload;

    connector.setMemberAffiliatedTeamRoleRequestAgreeAPI(this, state, url, params);
  },

  [SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_APPROVE](state, payload) {
    // console.log('SUBMIT_MEMBER_AFFILIATED_TEAM_ROLE_REQUEST_APPROVE (action) =========================== ', payload);
    const url = '/admin/authority/member/team/role/request/approve.json';
    const params = payload;

    connector.setMemberAffiliatedTeamRoleRequestApproveAPI(this, state, url, params);
  },

  [SUBMIT_MEMBER_EDIT_DATA](state, payload) {
    // console.log('SUBMIT_MEMBER_EDIT_DATA (action) =========================== ');
    const url = '/admin/authority/member/edit.json';
    const params = payload;

    connector.setEditMemberAPI(this, state, url, params);
  },

  [SUBMIT_JOB_CREATE_DATA](state, payload) {
    // console.log('SUBMIT_JOB_CREATE_DATA (action) =========================== ');
    const url = '/admin/authority/job/create.json';
    const params = payload;

    connector.setCreateJobAPI(this, state, url, params);
  },

  [SUBMIT_JOB_EDIT_DATA](state, payload) {
    // console.log('SUBMIT_JOB_EDIT_DATA (action) =========================== ');
    const url = '/admin/authority/job/edit.json';
    const params = payload;

    connector.setJobEditAPI(this, state, url, params);
  },

  [SUBMIT_JOB_REMOVE_DATA](state, payload) {
    // console.log('SUBMIT_JOB_REMOVE_DATA (action) =========================== ');
    const url = '/admin/authority/job/remove.json';
    const params = payload;

    connector.setJobRemoveAPI(this, state, url, params);
  },

  [SUBMIT_TEAM_CREATE_DATA](state, payload) {
    // console.log('SUBMIT_TEAM_CREATE_DATA (action) =========================== ');
    const url = '/admin/authority/team/create.json';
    const params = payload;

    connector.setTeamCreateAPI(this, state, url, params);
  },

  [SUBMIT_TEAM_EDIT_DATA](state, payload) {
    // console.log('SUBMIT_TEAM_EDIT_DATA (action) =========================== ');
    const url = '/admin/authority/team/save.json';
    const params = payload;

    connector.setTeamEditAPI(this, state, url, params);
  },

  [SUBMIT_TEAM_REMOVE_DATA](state, payload) {
    // console.log('SUBMIT_TEAM_REMOVE_DATA (action) =========================== ');
    const url = '/admin/authority/team/remove.json';
    const params = payload;

    connector.setTeamRemoveAPI(this, state, url, params);
  },

  [SUBMIT_ADD_MEMBER_TO_TEAM_DATA](state, payload) {
    // console.log('SUBMIT_ADD_MEMBER_TO_TEAM_DATA (action) =========================== ');
    const url = '/admin/authority/team/member.json';
    const params = payload;

    connector.setAddMemberToTeamAPI(this, state, url, params);
  },

  // //////////////////////////////////////////////////////////////////////////////////////////
  [SET_SLACK_ALARM](state, payload) {
    console.log('SET_SLACK_ALARM (action) =========================== ', payload);
    const url = '/system/alarm/slack/v1.json';
    const params = {
      message: payload,
    };

    connector.setSlackAlarmAPI(this, url, params);
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js